export const stripSearchAndHash = (to: string) => to.split(/[?#]/u)[0];
